export const SITE_ADDRESS = process.env.REACT_APP_URL;
export const WHATSAPP_ADDRESS = process.env.REACT_APP_WHATSAPP;
export const SCHOOL_NAME = process.env.REACT_APP_SCHOOL_NAME;
export const SKOOLAS_ACADEMIK_URL = process.env.REACT_APP_SKOOLAS_AKADEMIK_URL;

// Delay Render
export const TIME_DELAY = 500;

export const DEMO = true;
